import {
  FORGOT_PASSWORD_ROUTE,
  ANALYTICS_OCCUPATION_ROUTE,
  ANALYTICS_BOOKING_ROUTE,
  ANALYTICS_HEATMAP_ROUTE,
  ANALYTICS_ADOPTION_ROUTE,
  ANALYTICS_TEAM_ROUTE,
  USER_PLANNING_ROUTE,
  HOME_ROUTE,
  HOME_LEGACY_ROUTE,
  LOGIN_ROUTE,
  LOGIN_FIRST_ROUTE,
  LOGIN_PASSWORD_ROUTE,
  MANAGE_SPACES_ROUTE,
  TOGETHER_ROUTE,
  BOOKINGS_MINE_ROUTE,
  RTSM_ROUTE,
  RTSM_ROUTE_USER_CODE_V4,
  RTSM_ROUTE_USER_HASH,
  RTSM_ROUTE_USER_V4,
  SEARCH_SPACE_ROUTE,
  SCHEDULER_ROUTE,
  PROFILE_ROUTE,
} from '@jooxter/core';

export const GTM_VIEW_PAGE_MAPPING: Record<string, string> = {
  [FORGOT_PASSWORD_ROUTE]: 'Forgot Password',
  [ANALYTICS_OCCUPATION_ROUTE]: 'Analytics Occupation',
  [ANALYTICS_BOOKING_ROUTE]: 'Analytics Booking',
  [ANALYTICS_HEATMAP_ROUTE]: 'Analytics Heatmap',
  [ANALYTICS_ADOPTION_ROUTE]: 'Analytics Adoption',
  [ANALYTICS_TEAM_ROUTE]: 'Analytics Team',
  [USER_PLANNING_ROUTE]: 'Collaborators',
  [HOME_ROUTE]: 'Home',
  // The previous home, until it is deleted: compared with the new one (ND-6435).
  [HOME_LEGACY_ROUTE]: 'Home Legacy',
  [LOGIN_ROUTE]: 'Login',
  [LOGIN_FIRST_ROUTE]: 'First Connection',
  [LOGIN_PASSWORD_ROUTE]: 'Check Password',
  [MANAGE_SPACES_ROUTE]: 'Manage Resources',
  [TOGETHER_ROUTE]: 'Together',
  [BOOKINGS_MINE_ROUTE]: 'My bookings',
  [RTSM_ROUTE]: 'RTSM',
  [RTSM_ROUTE_USER_CODE_V4]: 'RTSM',
  [RTSM_ROUTE_USER_HASH]: 'RTSM',
  [RTSM_ROUTE_USER_V4]: 'RTSM',
  [SEARCH_SPACE_ROUTE]: 'Spaces',
  [SCHEDULER_ROUTE]: 'Spaces',
  [PROFILE_ROUTE]: 'My profile',
};
